import { useMutation, useQueryClient } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';

/**
 * DELETE /api/eraf/codes/groups/{groupCode} — 코드 그룹 삭제
 * 성공 시 ['common-code', 'list'] 쿼리 무효화
 */
export function useDeleteCodeGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (groupCode: string) => codeApi.deleteGroup(groupCode),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-code', 'list'] });
    },
  });
}
